/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Loader from '/client/src/components/Loader';
import { DELETE } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';

import EventPageDiscountCodesSearchbar from './searchbar';
import EventPageDetailDiscountCodesBody from './body';
import EventPageDetailDiscountCodesModal from './modal';
import EventPageDetailDicountCodesURLs from './bodyUrls';

import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';

import './styles.scss';
import _ from 'lodash';
import { convertToLocalTime } from '../../../../utils/jstz';

type PropsType = {
  match: {
    params: {
      tableTab?: string,
      subViewTab?: string,
      eventId: number | string
    }
  }
};

const items = [
  {
    link: 'discount-codes/codes',
    label: 'Discount codes'
  },
  {
    link: 'discount-codes/urls',
    label: 'Discount URLs'
  }
];

export const getValidTickets = (contextTickets: []): [] => { // this.context.eventDetail.tickets
  return _.filter(contextTickets, (item: {}): void => {
      let amount = 0;

      if (!isNaN(item.price)) {
        amount = amount + (+item.price);
      } else {
        return true;
      }

      if (!isNaN(item.merchant_fee)) {
        amount = amount + (+item.merchant_fee);
      }

      if (!isNaN(item.tax)) {
        amount = amount + (+item.tax);
      }

      return amount > 0;
    });
};

const EventPageDetailDicountCodes = ({ match }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const contextEvent = React.useContext(EventDetailContainerContext);
  const { params: { eventId, tableTab } } = match;
  const [isOpenModal, handleToggleModal] = React.useState(false);
  const [isOpenModalFor, handleToggleModalFor] = React.useState(null);
  const [discounts, setDiscounts] = React.useState([]);
  const [initialDiscounts, setInitialDiscounts] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [selectedRows, handleSelectRow] = React.useState([]);
  const [toggledClearRows, handleToggledClearRows] = React.useState(false);
  const _tableTab = tableTab || 'codes';
  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailDicountCodes-menuItems-${k}`}
        // className='active'
        className={`${(_tableTab ? _tableTab.toLowerCase() : '') === i.link.split('/')[1] ? 'active' : ''}`}
      >
        <Link to={`/events/${eventId}/manage/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });
  const isReadOnly = contextEvent.eventDetail.permission === 'Read';

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          const data = _.get(response, 'data.result.items', []);

          setDiscounts(data);
          setInitialDiscounts(data);
          setIsLoaded(true);
        } catch (e) {
          console.error('Can\'t get discounts list');
        }
      }
    },
    []
  );

  const handleRemoveDiscountGroup = async (): any => {
    if (!_.size(selectedRows)) {
      return;
    }

    CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);

    const removedGroupIds = _.map(selectedRows, (sr: {}): number => sr.group_id);

    try {
      await DELETE(`/api/v1/1/discounts/${eventId}`, {
        group_ids: removedGroupIds
      });

      const discountsUpdate = _.compact(_.map(discounts, (d: {}): any => {
        if (_.indexOf(removedGroupIds, d.group_id) < 0) {
          return d;
        }
      }));

      handleSelectRow([]);
      handleToggledClearRows(!toggledClearRows);
      setDiscounts(discountsUpdate);

      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    } catch (e) {
      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    }
  };

  const handleAddDiscount = (data: {}, status: string | boolean) => {
    const row = data[0];

    row.codes = _.map(data, (d: {}): {} => d.coupon_code);

    if (status === 'add') {
      row.applied_to_tickets = data[0].applied_to_ticket_id;

      if (!row.is_enable_expiration) {
        setDiscounts([
          ...discounts,
          {
            ...row,
            begin_time_utc: null,
            end_time_utc: null
          }
        ]);
      } else {
        setDiscounts([
          ...discounts,
          row
        ]);
      }
    } else {
      handleUpdateDiscount(row);
    }
  };

  const handleUpdateDiscount = (_d: {}) => {
    const updatedDiscounts = discounts.map((el: any): any => {
      if (el.group_id === _d.group_id) {
        return {
          ..._d,
          begin_time_utc: !_d.is_enable_expiration ? null : _d.begin_time_utc,
          end_time_utc: !_d.is_enable_expiration ? null : _d.end_time_utc
        };
      } return el;
    });

    handleSelectRow([]);
    handleToggledClearRows(!toggledClearRows);
    setDiscounts(updatedDiscounts);
  };

  const handleDiscountDisabled = (group_id: number, status: boolean) => {
    setDiscounts(discounts.map((_d: {}): {} => {
      if (_d.group_id === group_id) {
        return {
          ..._d,
          is_disabled: status
        };
      }
      return _d;
    }));
   };

  const handleSearch = (_str: string): void => {
    if (_str === '') setDiscounts(initialDiscounts);

    const str = _str.toLowerCase();

    const result = _.filter(discounts, (o) => {
      if (
        o.applied_to_tickets.filter(s => s.toLowerCase().includes(str)).length ||
        o.codes.filter(s => s.toLowerCase().includes(str)).length ||
        convertToLocalTime(o.end_time_utc, contextEvent.eventDetail.time_zone_id, 'MM-DD-YYYY hh:mm a z').includes(str) ||
        convertToLocalTime(o.begin_time_utc, contextEvent.eventDetail.time_zone_id, 'MM-DD-YYYY hh:mm a z').includes(str)
      ) {
        return o;
      }
    });

    setDiscounts(result);
  };

  return (
    <div className="panel panel-default EventPageDetailDicountCodes">
      <div className="navbar-page-toolbar send-mail-navbar panel-heading-color3">
        <div className="container-fluid" style={{ height: '50px' }}>
          <ul className="nav top-nav hidden-520">
            {menuItems}
          </ul>

          <ul className="nav">
            <li className="dropdown hide show-520">
              <a href="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="icon icon-bars" />
              </a>
              <ul className="dropdown-menu">
                {menuItems}
              </ul>
            </li>
          </ul>
        </div>

        {_tableTab && _tableTab.toLowerCase() !== 'urls' && isLoaded &&
          <EventPageDiscountCodesSearchbar
            eventId={eventId}
            handleShowModal={handleToggleModal}
            isOpenModalFor={isOpenModalFor}
            handleToggleModalFor={handleToggleModalFor}
            selectedRows={selectedRows}
            handleRemoveDiscountGroup={handleRemoveDiscountGroup}
            handleSelectRow={handleSelectRow}
            handleToggledClearRows={handleToggledClearRows}
            toggledClearRows={toggledClearRows}
            contextEvent={contextEvent}
            handleSearch={handleSearch}
            isReadOnly={isReadOnly}
          />
        }
      </div>

      {_tableTab && _tableTab.toLowerCase() !== 'urls' ?
        <>
          <Loader
            url={`/api/v1/1/discounts/${eventId}`}
            onLoaded={handleLoaded}
          >
            {!!_.size(discounts) ?
              <EventPageDetailDiscountCodesBody
                discounts={discounts}
                setDiscounts={setDiscounts}
                toggledClearRows={toggledClearRows}
                handleSelectRow={(tableState: {}) => {
                  handleSelectRow(tableState.selectedRows);
                  handleToggledClearRows(toggledClearRows);
                }}
                eventId={eventId}
                handleDiscountDisabled={handleDiscountDisabled}
                isReadOnly={isReadOnly}
              /> : <div className='panel-body'>
                Discount Codes not found
              </div>}
          </Loader>

          {isOpenModal &&
            <EventPageDetailDiscountCodesModal
              isOpen={isOpenModal}
              handleShowModal={handleToggleModal}
              handleAddDiscount={handleAddDiscount}
              isOpenModalFor={isOpenModalFor}
              discounts={discounts}
              selectedRow={selectedRows[0]}
              eventId={eventId}
              defaultContainerContext={context}
            />
          }
        </> :
        <EventPageDetailDicountCodesURLs
          eventId={eventId}
        />
      }
    </div>
  );
};

export default withRouter(EventPageDetailDicountCodes);
